import React from "react";
import Marquee from "react-fast-marquee";
import UNDPlogo from "../../../images/Logo/Undp.png";
import USAID from "../../../images/Logo/USAID-Logo.png";
import GobImage from "../../../images/Logo/GOB.png";
import RangamatiImage from "../../../images/Logo/rangamati.png";
import "../../../style/fundingPartner.css";

const FundingPartner = () => {
  return (
    <div className="fundingPartner_section">
      {/* <div className="container"> */}
      <div className="funding_title">
        <div className="container">
          {/* <img src={Logo} alt="" /> */}
          <h2>Our Partners</h2>
        </div>
      </div>
      <div className="partner_wrapper">
        {/* <div className="container"> */}
        <Marquee pauseOnClick>
          <div className="image_wrapper">
            <img src={UNDPlogo} alt="" />
            <img src={USAID} alt="" />
            <img src={GobImage} alt="" />
            <img src={RangamatiImage} alt="" />
          </div>
        </Marquee>
        {/* </div> */}
      </div>
      {/* </div> */}
    </div>
  );
};

export default FundingPartner;
